import { Component } from "@angular/core";
import {
	AbstractControl,
	UntypedFormBuilder,
	Validators
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { PasswordService } from "@core/services/auth/password.service";
import { ResetPassword } from "@data/schemas/password";
import { MessageToastService } from "@shared/services/message-toast.service";
import { passwordMatchValidator } from "@shared/utils/forms/custom-validators";

@Component({
	templateUrl: "./reset-password.component.html",
	styleUrls: ["./reset-password.component.scss"],
	standalone: false
})
export class ResetPasswordComponent {
	form = this.fb.group({
		codigoValidacaoSenha: [
			"",
			{
				validators: [Validators.required]
			}
		],
		confirmarSenhaGroup: this.fb.group(
			{
				novaSenha: ["", [Validators.required, Validators.minLength(6)]],
				confirmarSenha: [
					"",
					[Validators.required, Validators.minLength(6)]
				]
			},
			{
				validators: passwordMatchValidator({
					passwordField: "novaSenha",
					confirmPasswordField: "confirmarSenha"
				})
			}
		)
	});

	isLoadingBtn = false;

	constructor(
		private passwordService: PasswordService,
		private fb: UntypedFormBuilder,
		private router: Router,
		private route: ActivatedRoute,
		private messageToastService: MessageToastService
	) {}

	prepareResetPasswordData(): ResetPassword {
		return {
			validationCode: Number(
				this.form.get("codigoValidacaoSenha")?.value
			),
			newPassword: this.form.get("confirmarSenhaGroup")?.get("novaSenha")
				?.value as string,
			confirmNewPassword: this.form
				.get("confirmarSenhaGroup")
				?.get("confirmarSenha")?.value as string
		};
	}

	submit(): void {
		const resetPasswordData = this.prepareResetPasswordData();
		this.isLoadingBtn = true;
		this.passwordService
			.resetPassword({
				newPassword: resetPasswordData.newPassword,
				confirmNewPassword: resetPasswordData.confirmNewPassword,
				validationCode: resetPasswordData.validationCode
			})
			.subscribe({
				complete: () => {
					this.messageToastService.successTranslatedToast({
						title: "RESET_PASSWORD.TOAST_SUCCESS_TITLE",
						message: "RESET_PASSWORD.TOAST_SUCCESS"
					});
					void this.router.navigate(["../login"], {
						relativeTo: this.route
					});
				},
				error: () => {
					this.isLoadingBtn = false;
				}
			});
	}

	goToLoginPage(): void {
		void this.router.navigate(["../login"], {
			relativeTo: this.route
		});
	}

	get passwordGroup(): AbstractControl | null {
		return this.form.get("confirmarSenhaGroup");
	}
}
